import { render, staticRenderFns } from "./BannerNew.vue?vue&type=template&id=b23364e2&scoped=true&"
import script from "./BannerNew.vue?vue&type=script&lang=js&"
export * from "./BannerNew.vue?vue&type=script&lang=js&"
import style0 from "./BannerNew.vue?vue&type=style&index=0&id=b23364e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23364e2",
  null
  
)

export default component.exports